import Cookies from 'js-cookie';
import axios from 'axios';
import moment from 'moment';
import jwtDecode from 'jwt-decode';

// CONSTANTS
import { LEGACY_4BEE } from './constants';
import Routes from '../routes';

const SESSION_TOKEN = 'session-token';

export const isLoggedIn = () => {
  const sessionToken = sessionStorage.getItem(SESSION_TOKEN) ?? localStorage.getItem(SESSION_TOKEN);

  const currentPath = window.location.hash.replace('#', '');
  // console.log('currentPath: ', currentPath);

  // 🚨 ROTA PÚBLICA ESPECIAL — NÃO REDIRECIONAR
  if (currentPath.startsWith('/SamlHandler')) {
    return true; // Permite a rota abrir SEM token
  }

  if (!sessionToken) {
    const redirectPath = window.location.hash.substring(1);

    if (!sessionStorage.getItem('redirect_to') && redirectPath !== '/login') {
      sessionStorage.setItem('redirect_to', redirectPath);
      // console.log('Link para redirecionamento salvo:', redirectPath);
    }

    return false;
  }

  return !!sessionToken;
};

export const isSamlHandlerRoute = () => {
  const currentPath = window.location.hash.replace('#', '');
  return currentPath.startsWith('/SamlHandler');
};

export const isApiTokenExpired = (apiToken: string) => {
  const oneMinute = 30; // 30 seconds
  const expiration = parseInt((jwtDecode(apiToken) as any).exp, 10);
  const now = moment().unix();

  return now > expiration - oneMinute;
};

export const isApiTokenValid = (token: string | undefined | null) =>
  !!token && !isApiTokenExpired(token);

export const hasLegacyCookie = () => {
  const cookie = Cookies.get('Auth4Bee');
  return !!cookie;
};

export const getLegacySessionToken = () => {
  // delete axios.defaults.headers.common.Authorization;
  return axios.post(`${LEGACY_4BEE}/integration/GetConnectedUserCredentials`, null, {
    withCredentials: true,
  });
};

export const getApiToken = async () => {
  const sessionToken = sessionStorage.getItem(SESSION_TOKEN) ?? localStorage.getItem(SESSION_TOKEN);

  if (!sessionToken) {
    return null;
  }

  const headers = new Headers({
    Authorization: `Bearer ${sessionToken}`,
  });
  const response = await fetch(Routes.authenticateBusinessPath, {
    method: 'POST',
    headers,
  });

  if (!response.ok) {
    return null;
  }

  const newToken = await response.text();
  return newToken || null;
};

// export const getApiToken = async () => {
//   const response = await getAuthTokenCredentials();

//   const newToken = await response.text();
//   return newToken;
// };

// export const getUserAuthCondition = async () => {
//   const response = await getAuthTokenCredentials();
//   return response.status;
// };

// export const getAuthTokenCredentials = async () => {
//   const sessionToken = sessionStorage.getItem(SESSION_TOKEN) ?? localStorage.getItem(SESSION_TOKEN);

//   const headers = new Headers({
//     Authorization: `Bearer ${sessionToken}`,
//   });
//   const response = await fetch(Routes.authenticateBusinessPath, {
//     method: 'POST',
//     headers,
//   });

//   return response;
// };

export class AuthError extends Error {
  response: Response;

  constructor(message: string, response: Response) {
    super(message);
    this.name = 'Authencation Error';
    this.message = message;
    this.response = response;
  }
}
